import "./ExpeditionDetail.css";

type Case = {
  number: string;
  id: string;
  title: string;
  question: string;
  goal: string;
  work: string;
  result: string;
  flow: string[];
  note?: string;
  capture: string;
  evidence: string;
};

const cases: Case[] = [
  {
    number: "01", id: "model", title: "모델·애니메이션 파이프라인",
    question: "모델 변환, 애니메이션 상태 매핑과 Root Motion 적용",
    goal: "변환한 모델을 엔진에서 확인하고, 캐릭터 상태에 맞는 애니메이션을 연결하는 작업을 맡았습니다.",
    work: "Assimp 기반 ModelConverter·Viewer를 구성해 Mesh, Material, Bone, Weight와 Animation을 변환·확인했습니다. 경로 기반 매핑, AnimState와 Root Motion을 연결해 이동과 월드 액션에 필요한 애니메이션을 선택하고 이동량을 반영했습니다.",
    result: "변환한 모델과 애니메이션을 전투·탐험 상태에서 불러와 사용하도록 했습니다.",
    flow: ["ModelConverter", "ModelViewer", "AnimState", "Root Motion · Client"],
    note: "UE5는 오프라인 리타겟 도구로 사용했습니다. 리타겟 결과의 변환·매핑과 자체 엔진 적용이 제 구현 범위입니다.",
    capture: "ModelViewer에서 모델·본 확인 → 애니메이션 선택 → 실제 이동과 Root Motion 비교",
    evidence: "작업 이력: 781e157b5 모델 변환기·뷰어 / 64676c342 경로 기반 매칭 / 84c0285e5 GUID·class 기반 AnimState",
  },
  {
    number: "02", id: "modifier", title: "AnimationModifier 구조",
    question: "본 포즈에 머리카락과 의상의 보조 움직임 적용",
    goal: "머리카락이나 옷의 움직임을 추가할 때마다 캐릭터 상태 머신과 애니메이션 재생 코드를 수정하지 않도록 했습니다.",
    work: "기본 본 포즈 계산 이후 등록된 Modifier를 순서대로 평가하도록 구성했습니다. 각 Modifier가 대상 본 체인, 설정값, 활성 상태와 최종 포즈 반영 방식을 독립적으로 갖게 했습니다. 이 구조에 ChainModifier와 PhysicsModifier를 연결했습니다.",
    result: "머리카락·코트·케이프에 적용했습니다. 본 체인별 설정과 활성 상태를 따로 두고, 기본 포즈에 보정값을 더하거나 교체할 수 있게 했습니다.",
    flow: ["기본 포즈 계산", "AnimationModifier 평가", "Chain / Physics 보정", "최종 본 행렬"],
    capture: "같은 동작에서 Modifier OFF·ON 비교 / 머리카락·코트·케이프 클로즈업",
    evidence: "작업 이력: 47f0b1cc6 ChainModifier / ae83620b8 PhysicsModifier·케이프 / dc041ad41 물리 충돌 수정",
  },
  {
    number: "03", id: "map", title: "AI를 활용한 맵 파이프라인 통합",
    question: "에디터에서 저장한 내용이 Client에 반영되도록 수정",
    goal: "맵과 셰이더 담당자의 코드 사이에 데이터 형식과 적용 방식이 맞지 않는 부분이 있었습니다. 양쪽 코드를 확인하고 저장·로딩 규칙을 정리했습니다.",
    work: "AI를 작업 보조 도구로 활용하며 맵 에디터와 Client의 데이터 흐름을 정리했습니다. Static/Instanced Mesh 분할 저장, 모델별 Material Override와 Collision Sidecar 규칙을 설계하고 SceneContext, MapLoader, MapAdapter·MapCollisionAdapter에 구현했습니다.",
    result: "에디터에서 저장한 배치·재질·충돌 데이터를 Client에서 읽는 공통 경로를 만들고, 기존 포맷과의 호환도 처리했습니다.",
    flow: ["MapEditor", "분할 JSON · Sidecar", "Adapter 호환", "Client MapLoader"],
    note: "코드 분석과 구현에 AI를 활용했습니다. 공통 데이터 규칙 결정, 최종 코드 검토와 통합·검증은 제가 맡았습니다.",
    capture: "맵 배치·Material Override 수정 → 저장 → Client 재로드 / 충돌 데이터 표시",
    evidence: "작업 이력: 8a68c6139 분할 JSON 파서 / f192157f7 Override 확장 / ddc5f153e 모델별 충돌 데이터 로드",
  },
  {
    number: "04", id: "screenfx", title: "ScreenFx와 렌더 타깃",
    question: "전투 전환, 블러와 마스킹 효과",
    goal: "ScreenFx 인스턴스와 뷰어를 만들고, RT·MRT를 사용해 전투 전환과 화면 효과를 구현했습니다.",
    work: "마스크 전환, 카메라 모션 블러, RoseFlare를 작업했습니다. 렌더 타깃을 복사할 때 크기를 확인하는 처리를 추가했고, ScreenFx가 UI보다 먼저 그려지도록 렌더링 시점을 수정했습니다.",
    result: "효과 구현과 함께 렌더 타깃 크기 불일치와 UI 출력 순서 문제를 수정했습니다.",
    flow: ["렌더 타깃 입력", "ScreenFx 처리", "효과 결과 출력", "UI 렌더링"],
    note: "아래 흐름은 설명용 요약입니다. 팀 전체의 셰이더·후처리를 개인 작업으로 포함하지 않았습니다.",
    capture: "전투 전환·블러·RoseFlare 영상 / 입력 텍스처·마스크·결과 화면 나란히 비교",
    evidence: "작업 이력: 246196b5e RT·MRT / 9c03bec87 복사 크기 처리 / e1792bcb3 UI 이전 렌더링",
  },
  {
    number: "05", id: "interaction", title: "월드 상호작용과 Notify",
    question: "파쿠르, 로프 이동과 그래플링",
    goal: "탐험 중 사용하는 상호작용 이동을 애니메이션의 Root Motion과 연결했습니다.",
    work: "파쿠르에 Ray 판정을 적용하고, 애니메이션에서 XYZ 루트 이동량을 읽도록 수정했습니다. RopeAction을 구성해 로프 오르내리기와 그래플링을 추가했습니다. 이후 점프·낙하 로직과 이펙트·사운드 연동, 모델 Notify 싱크를 수정했습니다.",
    result: "월드 상호작용에 이동 애니메이션을 적용하고, 동작에 맞춰 이펙트와 사운드가 발생하도록 조정했습니다.",
    flow: ["상호작용 진입", "액션 애니메이션", "Root Motion 이동", "이펙트·사운드 연동"],
    note: "이동과 Notify는 애니메이션 재생 중 처리됩니다. 네 칸은 작업 내용을 요약한 것으로, 순차 호출을 뜻하지 않습니다.",
    capture: "파쿠르·로프·그래플링 플레이 / Notify 시점과 이펙트·사운드 확인",
    evidence: "작업 이력: 6ba01556f 파쿠르 / 30fef1e8c XYZ 루트 모션 / e9d74f9b2 그래플링 / 17ea3cb60 Notify 싱크",
  },
];

function CaseSection({ item }: { item: Case }) {
  return <section className="expedition-case" id={item.id}>
    <div className="container expedition-case-inner"><div className="expedition-case-heading"><span className="eyebrow">REPRESENTATIVE WORK / {item.number}</span><h2>{item.title}</h2><p>{item.question}</p></div>
      <div className="expedition-case-content"><div className="expedition-flow" aria-label={`${item.title} 데이터 흐름`}>{item.flow.map((step, index) => <div key={step}><span>{String(index + 1).padStart(2, "0")}</span><strong>{step}</strong></div>)}</div>
        <dl className="expedition-case-details"><div><dt>작업 배경</dt><dd>{item.goal}</dd></div><div><dt>구현 내용</dt><dd>{item.work}</dd></div><div><dt>적용·수정</dt><dd>{item.result}</dd></div></dl>{item.note && <p className="expedition-case-note">{item.note}</p>}
        <figure className="expedition-capture"><span>캡처 준비 중</span><p>{item.capture}</p></figure>
        <details className="expedition-evidence"><summary>작업 기록</summary><p>{item.evidence}</p></details>
      </div>
    </div>
  </section>;
}

export default function ExpeditionDetail() {
  return <main className="expedition-page">
    <div className="container expedition-breadcrumbs"><a href="/#projects">← 프로젝트 목록</a><span>/</span><span>Expedition 33</span></div>
    <header className="expedition-hero"><div className="container expedition-hero-inner"><span className="eyebrow">TEAM PROJECT / RECREATION</span><h1>Expedition <em>33</em></h1><p className="expedition-hero-lead">모델·애니메이션 시스템과 맵 데이터 통합</p><p className="expedition-hero-summary">모델·애니메이션, 머리카락과 의상 보정, 맵 데이터 연동, 화면 효과와 월드 상호작용을 맡았습니다.</p><div className="expedition-meta"><span>2026.04–07</span><span>8인 팀</span><span>C++20 · DirectX 11</span></div><a className="button primary" href="#overview">작업 보기 ↓</a></div></header>
    <div className="container"><nav className="expedition-local-nav" aria-label="Expedition 상세 목차"><a href="#overview">개요</a><a href="#model">모델·애니메이션</a><a href="#modifier">Modifier</a><a href="#map">맵 데이터</a><a href="#screenfx">ScreenFx</a><a href="#interaction">월드 상호작용</a><a href="#closing">관련 링크</a></nav></div>
    <section id="overview" className="expedition-overview container"><div><span className="eyebrow">OVERVIEW</span><h2>담당 작업</h2></div><div><p>《Clair Obscur: Expedition 33》의 턴제 전투와 월드 탐험을 자체 DirectX 11 엔진으로 재현한 8인 팀 프로젝트입니다. 학습 목적의 모작입니다.</p><p>모델 변환과 애니메이션 처리를 시작으로 머리카락·의상 Modifier, 맵 데이터 연동, ScreenFx와 월드 상호작용을 작업했습니다.</p><p className="expedition-draft">기존 Git 작업 이력과 포트폴리오 기록으로 정리한 초안입니다. 플레이 영상과 비교 캡처는 추가할 예정입니다.</p></div></section>
    {cases.map(item => <CaseSection item={item} key={item.id} />)}
    <section id="closing" className="expedition-closing"><div className="container expedition-closing-inner"><span className="eyebrow">LINKS</span><h2>관련 자료</h2><div className="expedition-links"><a href="https://app.notion.com/p/Expedition158-3d1f59d27d7180fe9e23f887cd6aeb10" target="_blank" rel="noopener noreferrer">Expedition 33 상세 포트폴리오 ↗</a><a href="https://github.com/SoexDobin" target="_blank" rel="noopener noreferrer">GitHub 프로필 ↗</a><a href="/projects/nier-automata/">다음 프로젝트: NieR: Automata →</a></div></div></section>
  </main>;
}
